// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Download = function Download(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.361 18.125c.504 0 .909-.388.909-.87 0-.483-.405-.871-.909-.871H3.64c-.503 0-.909.388-.909.87 0 .483.406.871.91.871zm-7.023-4.918a.933.933 0 0 0 1.325 0l4.846-4.934a.845.845 0 0 0-.038-1.23.937.937 0 0 0-1.283.037l-3.28 3.337V2.746c0-.483-.404-.871-.908-.871-.503 0-.909.388-.909.87v7.673L5.816 7.083a.934.934 0 0 0-1.283-.037.845.845 0 0 0-.038 1.23L9.34 13.21z"
  }));
};
